import { useLocalStorage } from '@rehooks/local-storage'
import { useCallback } from 'react'

import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { useHasConnectedBankAccount } from './useHasConnectedBankAccount'

export interface ConnectBankBannerState {
  isVisible: boolean
  onDismiss: () => void
}

export const useConnectBankBanner = (): ConnectBankBannerState => {
  const { hasConnectedBankAccount, isLoading } = useHasConnectedBankAccount()
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(LocalStorageKeys.ConnectBankBannerDismissed, false)

  const onDismiss = useCallback(() => setIsDismissed(true), [setIsDismissed])

  return { isVisible: !isLoading && !hasConnectedBankAccount && !isDismissed, onDismiss }
}
